import { hexAlpha } from '@client/core/utils/colors';

export const Variables = {
	gridColumnsMobile: 4,
	gridMarginMobile: '20px',
	gridGutterMobile: '20px',
	gridColumns: 16,
	gridMargin: '100px',
	gridGutter: '50px',
	gridMarginUltra: '100px',
	gridGutterUltra: '50px',
};

export const Fonts = {
	families: {
		body: "'Söhne', Tahoma, Helvetica, Arial, Roboto, sans-serif",
		title: 'Geomanist',
	},
	weights: {
		regular: 400,
		bold: 600,
	},
	sizes: {
		xsmall: 12,
		small: 14,
		medium: 16,
		large: 18,
		xlarge: 20,
		p6: 22,
		p5: 24,
		p4: 28,
		p3: 35,
		p2: 44,
		p1: 48,
		h6: 55,
		h5: 68,
		h4: 86,
		h3: 96,
		h2: 110,
		h1: 128,
	},
};

export const Index = {
	PixiBackground: 0,
	PixiForeground: 44,
	cookieBanner: 45,
	FullScreenMenu: 1001,
	mainMenuButton: 1003,
	FullScreenVideoPlayer: 46,
	TextOverVideoPlayer: 48,
	indexMenu: 1003,
	preloader: 1010,
	siteLoader: 1010,
	debug: 1020,
	papand: 1000,
};

export const Breakpoints = {
	tiny: '0px',
	mobile: '690px',
	tablet: '900px',
	laptop: '1024px',
	desktop: '1600px',
	largeDesktop: '1790px',
	ultra: '2200px',
};
export type BreakpointKey = keyof typeof Breakpoints;

export const presetColors = {
	lightGrey: '#f5f5f5',
	grey: '#e6e6e6',
	darkGrey: '#cccccc',
	offWhite: '#f7f3f2',
	offsetBlack: '#272627',
	blackish: '#262c2e',
	kissMeRed: '#f74d38',
	dust: '#f1e1d6',
	white: '#ffffff',
	pinkish: '#f3c4b7',
	sunkiss: '#ffae02',
	sunkissedContrast: '#c06800',
	solgult1: '#ffdf9a',
	nude: '#ffad98',
	himmelblue: '#92cddc',
	seablue: '#84aeff',
	weirdgreen: '#18bf7e',
	evergreen: '#0b593b',
	pissyellow: '#f6f2df',
	evergreenS1: '#0a472f',
	evergreenBright: '#157853',
};

export const Colors = {
	darkBackground: presetColors.blackish,
	lightBackground: presetColors.dust,
	darkText: presetColors.blackish,
	lightText: presetColors.white,
	lightButtonBackground: presetColors.white,
	mainMenuButtonBackground: presetColors.white,
	MainMenuButtonBackground: presetColors.white,
	preloaderBackground: presetColors.evergreen,
	footerLightBackground: presetColors.evergreen,
	footerDarkBackground: presetColors.evergreenS1,
	newsBackground: presetColors.sunkiss,
	favouriteBackground: presetColors.sunkissedContrast,
	defaultOverlayDim: hexAlpha(presetColors.evergreen, 0.5),
	ErrorPageBackground: presetColors.pissyellow,
	defaultLightGrey: presetColors.grey,
	defaultDarkGrey: presetColors.darkGrey,
	defaultOffWhite: presetColors.offWhite,
	defaultWhite: presetColors.white,
	footerButtonTextColor: presetColors.evergreen,
	loginButton: presetColors.evergreen,
	loginButtonIdle: presetColors.evergreenBright,
	error: presetColors.kissMeRed,
	transition: 0.4,
};

export default Variables;
